import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Box, Button } from "@mui/material";

interface FilterDisplayButtonProps {
  onClick: () => void;
  show: boolean;
}

const FilterDisplayButton = ({ onClick, show }: FilterDisplayButtonProps) => {
  const label = show ? "Hide Filter" : "Show Filter";
  const Chevrons = show
    ? KeyboardDoubleArrowLeftIcon
    : KeyboardDoubleArrowRightIcon;

  return (
    <Button
      variant="contained"
      className="rounded-pill hide"
      onClick={onClick}
      sx={{ minWidth: "175px", color: "#000000de" }}
    >
      <Box display="flex" justifyContent="space-evenly" flex={1}>
        <Chevrons />
        {label}
        <Chevrons />
      </Box>
    </Button>
  );
};
export default FilterDisplayButton;
